<template>
  <div class="w-full h-full fixed top-0 left-0 z-20">
    <div class="w-full h-full relative">
      <div
        @click="close"
        class="w-full h-full absolute top-0 left-0"
        style="background-color: rgba(0, 0, 0, 0.3)"
      ></div>
      <div
        class="w-300px absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2"
      >
        <div
          class="w-full bg-grey04 text-center text-xs text-white00 font-bold leading-25px rounded-t-10px relative"
        >
          廃棄する
          <div
            @click="close"
            class="w-14px h-14px bg-white00 rounded-full absolute top-1/2 right-10px transform -translate-y-1/2 cursor-pointer"
          >
            <div class="w-full h-full relative">
              <span
                class="h-px w-10px bg-grey04 absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 rotate-45"
              ></span>
              <span
                class="h-px w-10px bg-grey04 absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 -rotate-45"
              ></span>
            </div>
          </div>
        </div>
        <div class="w-full bg-white00 py-30px rounded-b-10px">
          <div class="w-fit mx-auto mb-30px">
            <p class="text-xs font-bold text-black01">
              本当に廃棄しますか？<br />復旧することができません。
            </p>
          </div>
          <div class="flex justify-center items-center">
            <button
              @click="submit"
              class="block px-15px leading-loose text-white00 text-xs bg-grey04 rounded-20px mr-20px"
            >
              廃棄する
            </button>
            <div
              @click="close"
              class="block px-20px leading-loose text-white00 text-xs bg-grey04 rounded-20px cursor-pointer"
            >
              やめる
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: String,
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      var data = {
        _token: document.querySelector('meta[name="csrf-token"]').content,
      };
      var form = document.createElement("form");
      form.style.visibility = "hidden";
      form.method = "POST";
      form.action = this.url;
      for (const [key, value] of Object.entries(data)) {
        console.log(`${key}: ${value}`);
        var input = document.createElement("input");
        input.name = key;
        input.value = value;
        form.appendChild(input);
      }
      document.body.appendChild(form);
      form.submit();
    },
  },
};
</script>
